module.exports = __webpack_public_path__ + "static/media/zeeshan@3x.a0dd197c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/team/zeeshan@3x.png
// module id = 678
// module chunks = 1